import { render, staticRenderFns } from "./DataExport.vue?vue&type=template&id=2463316c&scoped=true&"
import script from "./DataExport.vue?vue&type=script&lang=ts&"
export * from "./DataExport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2463316c",
  null
  
)

export default component.exports